angular
    .module("skillBuilderSaaS")
    .filter("localFromUtc", function () {
    return function (date) {
        if (!date) {
            return "";
        }
        if (typeof date === "string") {
            if (date.indexOf("Z") === -1 && date.indexOf("+") === -1) {
                date += "Z";
            }
            date = new Date(date);
        }
        return date;
    };
});
